import Axios from 'axios';

export interface AppVersion {
  timestamp: string;
}

export default class UpdateService {
  public static async getFrontendVersion(): Promise<AppVersion> {
    // With our default Axios config, the backend url will be prepended to every
    // request. As we want a relative request, pointing towards the S3 bucket,
    // I'll create an empty config to make my request.
    const response = await Axios.create({
      headers: {
        'Cache-Control': 'no-store',
        Expires: '0',
      },
    }).get(`/app-version.json`);

    return await response.data;
  }
}
